import React from "react";
import { Container, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Images/Logos/Logo.png";
import { useIsMobile } from "../utils/responsive";

export default function Topbar() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const handleLogoClick = () => {
    navigate("/home");
  };

  return (
    <Navbar className="bg-body-tertiary p-0 border-bottom-black">
      <Container fluid>
        <Navbar.Brand style={{ cursor: "pointer" }} onClick={handleLogoClick}>
          <img
            src={logo}
            alt="logo"
            style={{
              width: isMobile ? "100px" : "150px",
              height: isMobile ? "100px" : "150px",
            }}
          />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}
